import moment from 'moment';
import { loadLocalData, saveLocalData } from '@/store/state';

const STATE_SETTINGS_KEY = 'settings';

export const loadAuth = _store => {
	return loadLocalData(setSettings, _store, STATE_SETTINGS_KEY).then(() => {
		const auth = _store.state.settings.auth;
		// for (const key in auth) {
		// 	console.log(`auth, load, auth.${key}=`, auth[key]);
		// }
		return auth ? true : false;
	});
};

export const saveAuth = _store => {
	// const auth = _store.state.settings.auth;
	// for (const key in auth) {
	// 	console.log(`auth, save, auth.${key}=`, auth[key]);
	// }
	console.log('auth, save');
	return saveLocalData(STATE_SETTINGS_KEY, _store.state.settings);
};

export const setSettings = (_store, _group, _value) => {
	console.log(`auth, set-settings, ${_group}`);

	if (!_store || !_group || _group !== 'settings') {
		console.log(`auth, set-settings, not set, ${_group}`);
		return false;
	}
	// 用儲存的改寫預設值
	replaceSettings(_store, _value);
	return true;
};

// Setting Module
export const resetSetting = _store => {
	_store.commit('resetSetting');
};

export const changeSetting = (_store, _group, _name, _value) => {
	_store.commit('changeSetting', {
		group: _group,
		name: _name,
		value: _value,
	});
};

export const toggleSetting = (_store, _group, _name) => {
	_store.commit('toggleSetting', {
		group: _group,
		name: _name,
	});
};

export const deleteSetting = (_store, _group, _name) => {
	_store.commit('deleteSetting', {
		group: _group,
		name: _name,
	});
};

export const replaceSettings = (_store, _value) => {
	_store.commit('replaceSettings', {
		value: _value,
	});
};

export const changeSettingObject = (_store, _group, _value) => {
	_store.commit('changeSettingObject', {
		group: _group,
		value: _value,
	});

	//沒有加這一行，db的值commit後不會改變，但是在store db.js裡都正常
	// _store.state.db = JSON.parse(JSON.stringify(_value));

	console.log(`auth, change-setting-object, ${_group}`);
};

// 永續儲存頁面資料(memory與localStorage都更新)
export const setPageInfo = (_store, _label, _icon, _name, _path, _params) => {
	const old_auth = JSON.parse(JSON.stringify(_store.state.settings.auth));

	const _page = JSON.parse(
		JSON.stringify(old_auth.page ? old_auth.page : {})
	);
	_page.label = _label ? _label : _page.label;
	_page.icon = _icon ? _icon : _page.icon;
	_page.name = _name ? _name : _page.name;
	_page.path = _path ? _path : _page.path;
	_page.params = _params ? _params : _page.params;

	console.log(`auth, set-pageinfo, _page=${JSON.stringify(_page)}`);

	// 更新auth.page
	changeSetting(_store, 'auth', 'page', _page);

	// 更新localStorage
	saveLocalData(STATE_SETTINGS_KEY, _store.state.settings);
};

// 永續儲存頁面資料(memory與localStorage都更新)
export const setSubPageInfo = (_store, _path, _params) => {
	const old_auth = JSON.parse(JSON.stringify(_store.state.settings.auth));

	const _page = JSON.parse(
		JSON.stringify(old_auth.page ? old_auth.page : {})
	);
	_page.path = _path ? _path : _page.path;
	_page.params = _params ? _params : _page.params;

	console.log(`auth, set-subpageinfo, _page=`, _page);

	// 更新auth.page
	changeSetting(_store, 'auth', 'page', _page);

	// 更新localStorage
	saveLocalData(STATE_SETTINGS_KEY, _store.state.settings);
};

// 讀取頁面資料
export const getPageInfo = _store => {
	loadLocalData(setSettings, _store, STATE_SETTINGS_KEY);
	return _store.state.settings.auth.page;
};

// 檢查是否login session時間是否逾時
export const isLoginExpired = _store => {
	const exptime = _store.state.settings.auth.expTime;

	if (!exptime || !moment(exptime, 'yyyy-MM-DD HH:mm:ss', true).isValid()) {
		return true; // 沒有設定逾時時間，視為逾時
	}

	const expiryTime = moment(exptime, 'yyyy-MM-DD HH:mm:ss');
	const currentTime = moment();
	console.log(
		`auth, is-login-expired, exp=${expiryTime}, now=${currentTime}`
	);

	const expired = currentTime.isAfter(expiryTime);
	// changeState(_store, 'auth', 'isLogin', !expired);

	return expired;
};

export const hasValidAuthSession = _store => {
	const auth = _store?.state?.settings?.auth;
	return Boolean(
		auth?.isLogin &&
			auth.accessOUID &&
			auth.accessUID &&
			auth.accessId &&
			auth.accessToken &&
			!isLoginExpired(_store)
	);
};

const buildEmptyAuth = currentAuth => {
	const cleared = {};
	Object.keys(currentAuth || {}).forEach(key => {
		const value = currentAuth[key];
		if (Array.isArray(value)) {
			cleared[key] = [];
		} else if (value && typeof value === 'object') {
			cleared[key] = {};
		} else if (typeof value === 'boolean') {
			cleared[key] = false;
		} else {
			cleared[key] = '';
		}
	});
	cleared.isLogin = false;
	return cleared;
};

export const clearAuthSession = async _store => {
	const currentAuth = _store?.state?.settings?.auth;
	changeSettingObject(_store, 'auth', buildEmptyAuth(currentAuth));
	_store.commit('featureAccess/reset');
	_store.commit('resetDb');
	await saveAuth(_store);
};

export const ensureValidAuthSession = async _store => {
	const auth = _store?.state?.settings?.auth;
	if (!auth?.isLogin) return false;
	if (hasValidAuthSession(_store)) return true;

	await clearAuthSession(_store);
	return false;
};
